/** @format */

import {CartCheckoutContext} from 'frontier/cart/components/cart/cart_checkout_context';
import {onInputChange} from 'frontier/components/form/handle_change';
import {handleChange, InputWithErrorHandler} from 'frontier-form';
import {IfElse} from 'frontier-utilities';
import React, {useContext} from 'react';

export const PoForm = handleChange(props => {
    const ctx = useContext(CartCheckoutContext);

    return (
        <div>
            <div className="mb-4">
                <IfElse condition={!!ctx.cart.po_number}>
                    <h6 className="color-accent-primary m-0" style={{fontSize: 20}}>
                        <i className="fa fa-check me-2" />
                        P. O. Number
                    </h6>
                    <p className="m-0" style={{fontSize: 20}}>
                        Add a P.O. number <span className="color-structure-darker">(optional)</span>
                    </p>
                </IfElse>
            </div>
            <InputWithErrorHandler
                label="P.O. Number"
                placeholder="Enter your P.O. number"
                newestds
                maxLength={29}
                errorPath={'po_number'}
                value={ctx.cart.po_number || ''}
                onChange={e => {
                    const value = onInputChange('cart.po_number', e);
                    ctx.onChange(value);
                }}
            />
            {/* de activate it for now. If customers are confused about when their data is being saved, uncomment again*/}
            {/*<If condition={isCustomerAccountSaving}>*/}
            {/*    <p className="color-accent-primary"><i className="fa fa-spinner fa-spin"/>Saving...</p>*/}
            {/*</If>*/}
        </div>
    );
});
